import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Navigation from './components/Navigation';
import VisitorTracker from './components/VisitorTracker';
import Home from './pages/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import Admin from './pages/Admin';
import BonusContent from './pages/BonusContent';
import EmailTest from './pages/EmailTest';
import BookDetail from './pages/BookDetail';
import styled from 'styled-components';

const AppContainer = styled.div`
  min-height: 100vh;
  background: #f5f5f5;
`;

function App() {
  return (
    <Router>
      <GlobalStyles />
      <AppContainer>
        <VisitorTracker />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/bonus-content" element={<BonusContent />} />
          <Route path="/email-test" element={<EmailTest />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/book/:id/:slug?" element={<BookDetail />} />
        </Routes>
      </AppContainer>
    </Router>
  );
};

export default App;
